import React, {useEffect, useMemo, useState} from 'react';
import {useSiteConfig} from '../../data/ConfigContext';
import ExternalLink from '../ExternalLink';
import './sponsors.css';

const DEFAULT_INTERVAL_SECONDS = 6;

/**
 * Sponsor logos from the "sponsors" config post. If there are more sponsors than visible slots,
 * they rotate; hovering or focusing a logo pauses the rotation.
 */
const Sponsors = () => {
    const config = useSiteConfig();
    const sponsors = useMemo(() => config?.sponsors.sponsors ?? [], [config]);
    const slots = Math.min(Math.max(1, Math.floor(Number(config?.sponsors.visible) || 1)), sponsors.length);
    const intervalMs = Math.max(2, Number(config?.sponsors.interval_seconds) || DEFAULT_INTERVAL_SECONDS) * 1000;
    const rotates = sponsors.length > slots;

    const [offset, setOffset] = useState(0);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (!rotates || paused) return;
        const timer = window.setInterval(() => setOffset(current => (current + slots) % sponsors.length), intervalMs);
        return () => window.clearInterval(timer);
    }, [rotates, paused, slots, sponsors.length, intervalMs]);

    // preload all logos, so a rotation never shows an empty slot
    useEffect(() => {
        sponsors.forEach(sponsor => {
            new Image().src = sponsor.logo;
        });
    }, [sponsors]);

    if (!sponsors.length) return null;

    const shown = Array.from({length: slots}, (_, slot) => sponsors[(offset + slot) % sponsors.length]);

    return (
        <section className="sponsors" aria-label="Sponsoren"
                 onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}
                 onFocus={() => setPaused(true)} onBlur={() => setPaused(false)}>
            <h2 className="sponsors-title">Unsere Sponsoren</h2>
            <div className="sponsors-row">
                {shown.map((sponsor, slot) => (
                    // the key changes on every rotation, which replays the fade-in animation
                    <ExternalLink key={`${offset}-${slot}`} href={sponsor.link} className="sponsor" sponsored>
                        <img src={sponsor.logo} alt={sponsor.name}/>
                    </ExternalLink>
                ))}
            </div>
        </section>
    );
};

export default Sponsors;
